import { NgModule } from '@angular/core';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { SharedModule } from '@shared/shared.module';
import { FooterLinkColumnsComponent } from './components/footer-link-columns/footer-link-columns.component';
import { ContactFormComponent } from '../forms/contact-form/contact-form.component';
import { PressFormComponent } from '../forms/press-form/press-form.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  declarations: [
    FooterComponent,
    FooterLinkColumnsComponent,
    ContactFormComponent,
    PressFormComponent,
  ],
  exports: [FooterComponent, ContactFormComponent],
  imports: [SharedModule, NgxCaptchaModule, RecaptchaModule, RecaptchaFormsModule],
})
export class FooterModule {}
